<template>
          <v-dialog v-model="show" max-width="580" :fullscreen="$vuetify.breakpoint.xs" scrollable>
            <v-card>
                <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
                {{$t('SETTINGS_TITLE')}}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>


        <v-container>
          <v-tabs v-model="tab" fixed-tabs>
            <v-tab href="#generales"><v-icon left>mdi-format-list-bulleted</v-icon>{{$t('SETTINGS_TAB_GENERAL')}}</v-tab>
            <v-tab  v-if="enableTTS" href="#audio"><v-icon left>mdi-speaker</v-icon>{{$t('SETTINGS_TAB_AUDIO')}}</v-tab> 
          
          <v-tabs-items v-model="tab">
            <v-tab-item value="generales">
                    <v-form  dense ref="form">
                      <v-row dense> 
                        <v-col cols="12">
                          <v-switch color="#0099CC"
                            v-model="prefs.styleMode" true-value="on" false-value="off"
                            :label="$t('POPOVER_CHANGE_STYLE')"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12">
                          <v-switch color="#0099CC"
                            v-model="prefs.confirmActions" true-value="on" false-value="off"
                            :label="$t('POPOVER_PREFS_CONFIRM_ACTIONS')"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12">
                          <v-switch color="#0099CC"
                            v-model="prefs.confirmSequences" true-value="on" false-value="off"
                            :label="$t('POPOVER_PREFS_CONFIRM_SEQUENCES')"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12">
                          <v-switch color="#0099CC"
                            v-model="prefs.confirmDelete" true-value="on" false-value="off"
                            :label="$t('POPOVER_PREFS_CONFIRM_DELETE')"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12">
                          <v-switch color="#0099CC"
                            v-model="prefs.autoScroll" true-value="on" false-value="off"
                            :label="$t('POPOVER_PREFS_AUTO_SCROLL')"
                          ></v-switch>
                        </v-col>
                    </v-row>

                    </v-form>
            </v-tab-item>

            <v-tab-item value="audio">

              
                <v-form  dense ref="form2">

                      <v-row dense> 
                      <v-col cols="12" class="mx-auto">
                              <v-alert
                                v-model="showWarningMessage" 
                                border="left"  :icon="false" dense
                                type="warning" 
                              >
                                {{warningMessage}} <a v-if="showUpdateLink" @click="updateApp" style="text-decoration:underline;">{{$t('SETTINGS_UPDATE_REQUIRED_PRESS_HERE')}}</a>
                              </v-alert>
                      </v-col>  
                      </v-row>
                      
                      <v-row dense>  
                        <v-col cols="12">
                          <v-switch color="#0099CC" :disabled="showWarningMessage"
                            v-model="prefs.sequenceEndWarning" true-value="on" false-value="off"
                            :label="$t('POPOVER_PREFS_PLAY_NOTICE')"
                          ></v-switch>
                        </v-col>
                        
                         <v-col cols="12" style="text-align: center;">
                          <v-slider 
                              v-model="prefs.sequenceEndWarningSeconds"
                              class="align-center" :disabled="showWarningMessage || prefs.sequenceEndWarning ==='off'"
                              :max="15"
                              :min="1"
                              hide-details
                            >
                            </v-slider>
                            {{prefs.sequenceEndWarningSeconds}} {{$tc('POPOVER_PREFS_SECONDS',prefs.sequenceEndWarningSeconds)}}
                      </v-col>

                        <v-col cols="12">
                          <v-switch color="#0099CC" :disabled="showWarningMessage"
                            v-model="prefs.enableTextToSpeech" true-value="on" false-value="off"
                            :label="$t('SETTINGS_ADVERTISE_SEQUENCE')"
                          ></v-switch>
                        </v-col>
                        
                         <v-col cols="12">
                         <v-select color="#0099CC" v-model="selectedVoice"
                          :items="voices" :disabled="prefs.enableTextToSpeech ==='off'"
                          :label="$t('SETTINGS_VOICE')"
                          item-value="voiceURI"
                          :item-text="item => item.name +' ('+ item.lang+')'"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                        <v-checkbox v-model="prefs.saySequenceName" :label="$t('SETTINGS_SEQ_NAME')" color="#0099CC" true-value="on" false-value="off" :disabled="prefs.enableTextToSpeech ==='off'"></v-checkbox>
                        <v-checkbox v-model="prefs.saySequenceInfo1" :label="$t('SETTINGS_SEQ_INFO1')" color="#0099CC" true-value="on" false-value="off" :disabled="prefs.enableTextToSpeech ==='off'"></v-checkbox>
                        <v-checkbox v-model="prefs.saySequenceInfo2" :label="$t('SETTINGS_SEQ_INFO2')" color="#0099CC" true-value="on" false-value="off" :disabled="prefs.enableTextToSpeech ==='off'"></v-checkbox>
                        </v-col>

                    </v-row>

                    </v-form>

            </v-tab-item>
          </v-tabs-items>
           </v-tabs>
          
          </v-container>


            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
                <v-spacer></v-spacer>
              <v-btn color="secondary rundown-dialog-btn" @click="udpateSettings">{{$t('SETTINGS_SAVE')}}</v-btn> 
              <v-btn color="primary rundown-dialog-btn" text @click="close">{{$t('SETTINGS_CANCEL')}}</v-btn> 
             </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
 import BaseModule from './BaseModule'
  export default {
    name: 'SettingsDialog', 
    mixins: [BaseModule],
    props: [],
    data(){
        return {  
             tab: null, 
             show: false,
             voices: [],
             selectedVoice: null,
             showWarningMessage: true,
             warningMessage: null,
             showUpdateLink: false,
             enableTTS: true,
             prefs: {
                 confirmActions: "on",
                 styleMode: "on",
                 confirmSequences: "on",
                 confirmDelete: "on",
                 enableTextToSpeech: "on",
                 saySequenceName: "off",
                 saySequenceInfo1: "off",
                 saySequenceInfo2: "off",
                 autoScroll: "off",
                 sequenceEndWarning: "off",
                 sequenceEndWarningSeconds: 5
             },
        }

    },   
    methods: {  
        udpateSettings() {

            if (this.$refs.form && !this.$refs.form.validate()) {
              this.tab="generales";
              return;
            }

            if (this.$refs.form2 && !this.$refs.form2.validate()) {
              this.tab="audio";
              return;
            }

            this.prefs.selectedVoiceURI=this.selectedVoice?this.selectedVoice:window.rundownApp.speech.defaultVoiceURI;

            window.rundownApp.prefs = this.prefs;
            
            window.rundownApp.fileManager.getInstance().SavePreferences();

            window.rundownApp.ChangeStyle(window.rundownApp.prefs.styleMode);

            this.close();
        },
        updateApp() {
            if (window.rundownApp.device.platform==="ios")
              window.sp_openURl(window.appstore_link);
            else
              window.sp_openURl(window.googleplay_link);
        },
        close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
        showSettings()
        {  
            this.show=true;

            this.voices = window.rundownApp.speech.voices;

            if (!window.rundownApp.prefs.enableTextToSpeech)
              window.rundownApp.prefs.enableTextToSpeech="off";

            if (!window.rundownApp.prefs.saySequenceName)
            window.rundownApp.prefs.saySequenceName="on";

            if (!window.rundownApp.prefs.saySequenceInfo1)
            window.rundownApp.prefs.saySequenceInfo1="off";

            if (!window.rundownApp.prefs.saySequenceInfo2)
            window.rundownApp.prefs.saySequenceInfo2="off";

            if (!window.rundownApp.prefs.sequenceEndWarning)
            window.rundownApp.prefs.sequenceEndWarning="off";

            if (!window.rundownApp.prefs.autoScroll)
            window.rundownApp.prefs.autoScroll="off";

            if (!window.rundownApp.prefs.sequenceEndWarningSeconds)
            window.rundownApp.prefs.sequenceEndWarningSeconds=5;

            this.prefs = window.rundownApp.prefs;
            
            //Voz
            let voiceURI = this.prefs.selectedVoiceURI ? this.prefs.selectedVoiceURI : window.rundownApp.speech.defaultVoiceURI;
            
            this.selectedVoice = voiceURI;

            if (!this.selectedVoice)
              this.selectedVoice = window.rundownApp.speech.defaultVoiceURI;


            this.showUpdateLink=false;
            if (window.rundownApp.speech.available===false)
            {
              this.warningMessage = this.$t('SETTINGS_SPEECH_NOT_SUPPORTED');
              this.showWarningMessage = true;
            }
            else
            if (!window.isPremium())
            {
                this.warningMessage = this.$t('SETTINGS_PREMIUM_REQUIRED');
                this.showWarningMessage = true;
            }
            else
            if (window.rundownApp.isCordova===true && window.rundownApp.device.nativeVersion<'2.0')
            {
              this.warningMessage = this.$t('SETTINGS_UPDATE_REQUIRED');
              this.showWarningMessage = true;
              this.showUpdateLink=true;
            }
            else
              this.showWarningMessage=false;
            

            if (this.showWarningMessage===true)
            {
              this.prefs.sequenceEndWarning = "off";
              this.prefs.enableTextToSpeech = "off";
            }
              

            window.rundownApp.device.backButtonCallback = this.close;
        } 
      },
  }
</script>
 